"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.opacify = exports.hexToRgb = void 0;
var lodash_1 = require("lodash");
/**
 * Little utility to return a value from a color path. This needs work. Maybe use default props instead of passing
 * in a defaultColor here.
 *
 * @param color
 * @param theme
 * @param defaultColor
 * @returns {*}
 */
var parseColor = function (color, theme, defaultColor) {
    if (color === 'transparent')
        return 'transparent';
    if (color === 'inherit')
        return 'inherit';
    if (!color)
        return defaultColor;
    if (color && typeof color === 'string' && color.includes('#')) {
        return color;
    }
    return lodash_1.get(theme, color, defaultColor) !== 'undefined'
        ? lodash_1.get(theme, color, defaultColor)
        : defaultColor;
};
/**
 * Converts hex colors to rbg. From https://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb
 *
 * @param hex
 */
exports.hexToRgb = function (hex) {
    var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    var hexString = hex.replace(shorthandRegex, function (m, r, g, b) {
        return r + r + g + g + b + b;
    });
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hexString);
    return result ? {
        b: parseInt(result[3], 16),
        g: parseInt(result[2], 16),
        r: parseInt(result[1], 16),
    } : null;
};
/**
 * Theme utility which accepts a Hexadecimal color value and opacity and returns an rgba() value.
 *
 * @param hexColor
 * @param alpha
 */
exports.opacify = function (hexColor, alpha) {
    var rgbColor = exports.hexToRgb(hexColor);
    return rgbColor ? "rgba(" + rgbColor.r + ", " + rgbColor.g + ", " + rgbColor.b + ", " + alpha + ")" : hexColor;
};
exports.default = parseColor;
//# sourceMappingURL=colorHelpers.js.map